<template>
  <VDialog
    v-model="props.show"
    :max-width="props.maxWidth || 'fit-content'"
    :min-width="width < 350 ? '100%' : props.minWidth || '350px'"
    :height="props.height || 'auto'"
    :transition="props.transition"
    :persistent="props.persistent"
    :fullscreen="width > props.maxWidth ? false : $vuetify.display.smAndDown">
    <VCard class="bg-card-background">
      <VCardTitle class="d-flex bg-surface bg-primary fix-card-header align-center">
        <VToolbarTitle class="flex-1 ps-2 pa-2 align-self-center">
          {{ props.translatedTitle || $t(props.title) }}
        </VToolbarTitle>
        <slot name="title-buttons" />
        <VBtn icon @click="close">
          <VIcon>mdi-close</VIcon>
        </VBtn>
      </VCardTitle>
      <VCardText class="mt-5 pt-0">
        <slot name="content" />
      </VCardText>

      <VCardActions v-if="props.enableCustomButtons" class="justify-end fix-card-footer">
        <slot name="dialog-buttons" />
      </VCardActions>
      <VCardActions v-else-if="props.enableCloseButton || props.enableSaveButton" class="justify-end fix-card-footer">
        <CancelButton v-if="props.enableCloseButton" color="error" :disabled="props.loading" @click="close">
          {{ t(props.negativeBtnText) }}
        </CancelButton>
        <slot name="buttons" />
        <VSpacer />
        <PrimaryButton v-if="props.enableSaveButton" :disabled="props.disableSaveButton" :loading="props.loading" @click="save">
          {{ t(props.positiveBtnText) }}
        </PrimaryButton>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script setup>
import CancelButton from '@/components/button/CancelButton.vue';
import PrimaryButton from '@/components/button/PrimaryButton.vue';
import i18n from '@/plugins/i18n';
import { ref } from 'vue';
import { useDisplay } from 'vuetify';

const props = defineProps({
  show: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: null,
  },
  translatedTitle: {
    type: String,
    default: null,
  },
  count: {
    type: Number,
    default: null,
  },
  enableCloseButton: {
    type: Boolean,
    default: true,
  },
  enableSaveButton: {
    type: Boolean,
    default: true,
  },
  disableSaveButton: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: [Number, String],
    default: 0,
  },
  minWidth: {
    type: [Number, String],
    default: '350px',
  },
  height: {
    type: [Number, String],
    default: 0,
  },
  transition: {
    type: String,
    default: 'fade-transition',
  },
  persistent: {
    type: Boolean,
    default: true,
  },
  enableCustomButtons: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  positiveBtnText: {
    type: String,
    default: 'save',
  },
  negativeBtnText: {
    type: String,
    default: 'cancel',
  },
});

const { width } = useDisplay();
const emit = defineEmits(['close', 'save']);

const { t } = i18n.global;

const close = () => {
  emit('close');
};

const save = () => {
  emit('save');
};
</script>
